export const POPULATE_COLUM_TYPE = 'populate';
export const LABEL_COLUM_TYPE = 'label';
export const CHIP_COLUM_TYPE = 'chip';
export const STORE_COLUM_TYPE = 'store';
export const MAKE_COLUM_TYPE = 'make';
export const TEXT_COLUM_TYPE = 'text';
export const LINK_COLUM_TYPE = 'link';
export const DATE_COLUM_TYPE = 'date';
export const RATING_COLUM_TYPE = 'rating';
export const AVATAR_COLUM_TYPE = 'avatar';
export const USER_STORES_COLUM_TYPE = 'userStores';
export const ACCESS_LEVEL_COLUM_TYPE = 'accessLevel';
export const IS_ACTIVE_COLUM_TYPE = 'isActive';
export const STRING_ARRAY_COLUM_TYPE = 'stringArray';

export const PRIORITY_COLOR_TYPE = 'priority';
export const STATUS_COLOR_TYPE = 'status';
